// src/pages/HomePage.js - Updated with Modal
import React, { useState, useEffect } from 'react';
import './HomePage.css';
import ServiceModal from '../components/ServiceModal';

// Import all images
import heroImage from '../assets/images/hero-home.png';
import sydneyImage from '../assets/images/sydney-city.jpg';
import checkedIcon from '../assets/images/icon-shape-checked.png';
import home2Image from '../assets/images/home-2.png';
import home3Image from '../assets/images/home-3.png';

// Import carousel images
import paintingImg from '../assets/images/painting.png';
import treeTrimmingImg from '../assets/images/tree-trimming.png';
import gardeningImg from '../assets/images/gardening.png';
import waterproofingImg from '../assets/images/waterproofing.png';
import pressureWashingImg from '../assets/images/pressure-washing.png';
import generalMaintenanceImg from '../assets/images/general-maintanance.png'; /*USING AS WASTE MANAGAMENTE*/

// Import pop images for modal
import paintingPop from '../assets/images/painting_pop.png';
import gardeningPop from '../assets/images/gardening_pop.png';
import waterproofingPop from '../assets/images/waterproofing_pop.png';
import wasteManagementPop from '../assets/images/waste_management_pop.png';
import generalMaintenancePop from '../assets/images/general_maintenance_pop.png';
import pressureWashingPop from '../assets/images/pressurewashing_pop.png';

const HomePage = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [slideDirection, setSlideDirection] = useState('next');
  const [selectedService, setSelectedService] = useState(null);

  const servicesData = [
    {
      id: 1,
      title: 'PAINTING',
      carouselImage: paintingImg,
      heroImage: paintingPop,
      heroText: 'Interior and exterior painting for commercial and residential buildings, including touch-ups, full repaints, protective coatings, and line marking',
      activitiesList: [
        'Colour and coating consultation.',
        'Surface preparation (sanding, patching, priming).',
        'Application by licensed painters (brush/roller/spray).',
        'Multi-coat process with drying time management.',
        'Final inspection and touch-ups.'
      ],
      advantagesList: [
        'Minimal disruption to tenants',
        'Durable finish',
        'Professional painters',
        'Quality material'
      ],
      processList: ['Quote', 'Prepare', 'Paint', 'Cleaning', 'Inspect', 'Handover']
    },
    {
      id: 2,
      title: 'GARDENING AND TREE TRIMMING',
      carouselImage: gardeningImg,
      heroImage: gardeningPop,
      heroText: 'Routine and corrective garden maintenance for commercial and residential properties, including planting, weeding, mulching, fertilising, tree trimming and pruning.',
      activitiesList: [
        'Site-specific garden plan creation.',
        'Scheduled visits (weekly/fortnightly/monthly).',
        'Hand weeding and mechanical edging.',
        'Mulching and slow-release fertilising.',
        'Green waste removal and composting.'
      ],
      advantagesList: [
        'Curb appeal',
        'Plant health',
        'Reduced water usage',
        'Up level appearance',
        'Safer environment'
      ],
      processList: ['Assess', 'Plan', 'Maintain', 'Dispose', 'Report']
    },
    {
      id: 3,
      title: 'WATERPROOFING',
      carouselImage: waterproofingImg,
      heroImage: waterproofingPop,
      heroText: 'Application of liquid membranes, sealants, and sheet systems to prevent water ingress in roofs, basements, bathrooms, and balconies.',
      activitiesList: [
        'Moisture testing and substrate preparation.',
        'Repair of cracks and joints.',
        'Application of primer and waterproofing membrane (spray/roll/trowel).',
        'Curing and flood testing.',
        'Final sealing and warranty issuance.'
      ],
      advantagesList: [
        'Prevents structural damage',
        'Prevents mould',
        'Avoid tenant disruption',
        'Creates cleaner and safer environments'
      ],
      processList: ['Diagnose', 'Prepare', 'Apply', 'Test', 'Guarantee']
    },
    {
      id: 4,
      title: 'WASTE MANAGEMENT',
      carouselImage: generalMaintenanceImg,
      heroImage: wasteManagementPop,
      heroText: 'Integrated collection, sorting, and disposal of general waste, recycling, organics, and hazardous materials from commercial and residential buildings.',
      activitiesList: [
        'Waste audit and bin flow analysis.',
        'Right-sizing bins and scheduling pickups.',
        'Training cleaning staff on segregation.',
        'Partnering with licensed recyclers.',
        'Monthly waste diversion reports.'
      ],
      advantagesList: [
        'Lower landfill costs',
        'Compliance with council rules',
        'ESG reporting'
      ],
      processList: ['Audit', 'Optimise', 'Collect', 'Recycle', 'Report']
    },
    {
      id: 5,
      title: 'GENERAL MAINTENANCE',
      carouselImage: generalMaintenancePop,
      heroImage: generalMaintenancePop,
      heroText: 'Ongoing repair and upkeep of building elements and equipment, including doors, windows, locks, taps, lights, shelving, handrails, and minor plaster or tile repairs.',
      activitiesList: [
        'Planned preventative inspections (monthly/quarterly).',
        'Mobile technicians dispatched with job-specific kits.',
        'On-site diagnosis and repair (first-time fix target).',
        'Parts replacement using approved suppliers.',
        'Post-repair testing and site clean-up.',
        'Digital sign-off with notes.'
      ],
      advantagesList: [
        'Reduced downtime',
        'Extended asset life',
        'Single point of accountability',
        'No need for multiple trades'
      ],
      processList: ['Take request', 'Dispatch', 'Repair', 'Test', 'Close', 'Report']
    },
    {
      id: 6,
      title: 'PRESSURE WASHING',
      carouselImage: pressureWashingImg,
      heroImage: pressureWashingPop,
      heroText: 'High-pressure cleaning for exterior surfaces including roofs, driveways, pathways, building facades, loading docks, car parks, bins areas, and sandstone, concrete or brick surfaces.',
      activitiesList: [
        'Assessment before job',
        'Surface protection & setup',
        'Cleaning process',
        'Roof cleaning:',
        'Driveways & pathways:',
        'Facades & car parks:',
        'Waste recovery & final care:'
      ],
      advantagesList: [
        'High-quality products & cutting-edge machinery',
        'Organisation and environmental care',
        'Surface care and protection'
      ],
      processList: ['Protect', 'Pre-treat', 'Wash', 'Rinse', 'Recover', 'Inspect', 'Report']
    }
  ];

  const services = servicesData.map(s => ({
    id: s.id,
    title: s.title,
    image: s.carouselImage,
    alt: `${s.title} Services`
  }));

  const nextSlide = () => {
    setSlideDirection('next');
    setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
  };

  const prevSlide = () => {
    setSlideDirection('prev');
    setCurrentIndex((prevIndex) => (prevIndex - 1 + services.length) % services.length);
  };

  const goToSlide = (index) => {
    setSlideDirection(index > currentIndex ? 'next' : 'prev');
    setCurrentIndex(index);
  };

  const handleCardClick = (serviceId) => {
    const service = servicesData.find(s => s.id === serviceId);
    setSelectedService(service);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedService(null);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        nextSlide();
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, currentIndex]);

  const pauseAutoPlay = () => setIsAutoPlaying(false);
  const resumeAutoPlay = () => setIsAutoPlaying(true);

  const getRotatingImages = () => {
    const result = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentIndex + i) % services.length;
      result.push(services[index]);
    }
    return result;
  };

  const rotatingImages = getRotatingImages();

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-container">
            <div className="hero-image-container">
              <img src={heroImage} alt="Vanguard Hero Background" className="hero-image" />
              <div className="hero-text-overlay">
                <div className="hero-text-content">
                  PROTECTING, PRESENTING<br />
                  AND ENHANCING YOUR ASSET
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Sydney Section */}
      <section className="about-sydney">
        <div className="container">
          <div className="about-sydney-grid">
            <div className="about-content">
              <div className="text-block top-block">
                <p className="large-text">
                  At Vanguard we deliver<br />
                  professional, reliable and<br />
                  detail-driven property care<br />
                  solutions across Sydney.
                </p>
              </div>
              <div className="text-block bottom-block">
                <p className="medium-text">Our systems are designed to support:</p>
                <ul className="support-list">
                  <li>Residential strata buildings</li>
                  <li>Mixed-use developments</li>
                  <li>Commercial strata properties</li>
                </ul>
              </div>
            </div>
            <div className="image-wrapper">
              <img src={sydneyImage} alt="Sydney City" className="sydney-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Value Boxes Section */}
      <section className="value-boxes">
        <div className="container">
          <div className="value-boxes-grid">
            <div className="value-box">
              <img src={checkedIcon} alt="Checked" className="box-icon" />
              <div className="box-content">
                <span className="box-line">ASSET</span>
                <span className="box-line">VALUE</span>
              </div>
            </div>
            <div className="value-box">
              <img src={checkedIcon} alt="Checked" className="box-icon" />
              <div className="box-content">
                <span className="box-line">SAFETY</span>
                <span className="box-line">COMPLIANCE</span>
              </div>
            </div>
            <div className="value-box">
              <img src={checkedIcon} alt="Checked" className="box-icon" />
              <div className="box-content">
                <span className="box-line">TENANT</span>
                <span className="box-line">EXPERIENCE</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="value-proposition">
        <div className="shadow-overlay"></div>
        
        <div className="section-first">
          <div className="image-wrapper-first">
            <img src={home2Image} alt="Vanguard Property" className="section-image" />
          </div>
          <div className="text-wrapper-first">
            <p className="proposition-text">
              With Vanguard every property is<br />
              presented at its best, protected for<br />
              the long term and maintained with<br />
              operational excellence.
            </p>
          </div>
        </div>

        <div className="section-second">
          <div className="second-section-content">
            <div className="image-wrapper-second">
              <img src={home3Image} alt="Vanguard Projects" className="section-image" />
            </div>
            <div className="text-wrapper-second">
              <p className="proposition-text-light">
                Projects are managed with<br />
                structure, accountability and<br />
                precision, ensuring minimal<br />
                disruption and maximum<br />
                visual and functional impact.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Carousel Section */}
      <section className="services-carousel">
        <div className="container">
          <h2 className="services-title">Our services</h2>
          
          <div 
            className="carousel-wrapper"
            onMouseEnter={pauseAutoPlay}
            onMouseLeave={resumeAutoPlay}
          >
            <button className="carousel-arrow prev" onClick={prevSlide}>
              <i className="fas fa-chevron-left"></i>
            </button>

            <div className="carousel-content">
              {rotatingImages.slice(0, 3).map((service, idx) => (
                <div 
                  key={`${service.id}-${currentIndex}-${idx}`} 
                  className={`service-card ${slideDirection}`}
                  onClick={() => handleCardClick(service.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="service-image-wrapper">
                    <img 
                      src={service.image} 
                      alt={service.alt} 
                      className="service-image" 
                    />
                    <div className="service-title-overlay">
                      <h3>{service.title}</h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <button className="carousel-arrow next" onClick={nextSlide}>
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>

          <p className="services-footer-text">
            Creating environments that look better, perform better and last longer.
          </p>

          <div className="carousel-dots">
            {services.map((_, index) => (
              <button
                key={index}
                className={`dot ${currentIndex === index ? 'active' : ''}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedService && (
        <ServiceModal service={selectedService} onClose={closeModal} />
      )}
    </div>
  );
};

export default HomePage;